import { useOnlineStatus } from "@/hooks/useOnlineStatus";
import styles from "./OfflineBanner.module.css";

/**
 * Sin red (interaction.md §3): banner fijo arriba, lo ya cargado se queda y al volver la red lo dice 3 s.
 * La región `role="status"` existe siempre para que el lector de pantalla anuncie los dos cambios.
 */
export function OfflineBanner() {
  const estado = useOnlineStatus();
  return (
    <div role="status" aria-live="polite">
      {estado === "sin-red" ? (
        <p className={`${styles.banner} ${styles.offline}`}>
          <svg className={styles.icon} viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M1 1l10 10M2 5.2a6 6 0 0 1 2.2-1.3M10 5.2A6 6 0 0 0 6.8 3.4M4 7.4a3 3 0 0 1 1-.7M8 7.4a3 3 0 0 0-1-.7" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" /></svg>
          Sin conexión a internet. Lo que ves puede no estar al día.
        </p>
      ) : null}
      {estado === "recuperada" ? (
        <p className={`${styles.banner} ${styles.online}`}>
          <svg className={styles.icon} viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2 6.5l2.5 2.5L10 3.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" /></svg>
          Conectado de nuevo.
        </p>
      ) : null}
    </div>
  );
}
